import React from 'react';
import Footer from '../Components/Footers/Footer';
import Header from '../Components/Headers/Header';
import '../assests/css/Home.css';
// import SlickSilder from '../Components/Slider';
import Slider from "react-slick";

import BookTaxiNow from '../Components/HomePage/BookTaxiNow';
import Testimonial from '../Components/HomePage/Testimonials';
import Process from '../Components/HomePage/Process';
import PremiumVeh from '../Components/HomePage/Premium_Veh';
import WeOffer from '../Components/HomePage/WeOffer';
import StandForYou from '../Components/HomePage/StandForYou';
import TaxiRates from '../Components/HomePage/TaxiRates';
import TopSlider from '../Components/HomePage/TopSlider';
import { useParams } from 'react-router-dom';
import VideoSec from '../Components/HomePage/VideoSec';

const HomePage = () => {
 
    return (
        <div className='home'>
            <section className='bg-home-header-top-sect '>
                <Header />
                <TopSlider />
            </section>
            <section className='book_taxi_now mt-5'>
                <BookTaxiNow />
            </section>
            <section className='video_sec mt-5'>
                <VideoSec />
            </section>
            <section className='testimonials mt-5'>
                <Testimonial />
            </section>
            <section className='process pb-5'>
                <Process />
            </section>
            <section className='our_premium_vechiles py-5'>
                <PremiumVeh />
            </section>
            <section className='easy_booking py-5'>
                <WeOffer />
            </section>
            <section className='stand_for_you py-5'>
                <StandForYou />
            </section>
            <section className='taxi_rates pt-5 pb-4'>
                <TaxiRates />
            </section>
            <Footer />
        </div>
    );
};

export default HomePage;